window.Products.DeviceCase.GalaxyS8 = function() {
};
window.Products.DeviceCase.GalaxyS8.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS8.id = 68;
window.Products.DeviceCase.GalaxyS8.slug = 'galaxy-s8';

window.Products.DeviceCase.GalaxyS8.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.rotation.x = Math.PI;
	modelViewer.object.position.y = -0.73;
	modelViewer.camera.position.z = 6;
};

window.Products.DeviceCase.GalaxyS8.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.5;
	controls.maxDistance = 4.5;
};